"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeSiweMessage = void 0;
function sanitizeSiweMessage(message) {
    // replace all escaped double quotes with single quotes.
    return message.replace(/\"/g, "'");
}
exports.sanitizeSiweMessage = sanitizeSiweMessage;
//# sourceMappingURL=siwe.js.map